export const coresPortas = {
  MDF: "#0d3972",
  M25: "#086739",
  PVC: "#686869",
  CAMARAO: "#db3c14",
  CRU: "#964B00",
};
